import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { routerMiddleware } from "connected-react-router";
import rootReducer, { history } from "./RootReducer";

var configureStore = function configureStore() {
  var composeEnhancer = !window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
    traceLimit: 25
  }) || compose;
  var store = createStore(rootReducer, {}, compose(composeEnhancer(applyMiddleware(routerMiddleware(history), thunk))));
  return {
    store: store,
    history: history
  };
};

export default configureStore;